const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

export const environment = {
  // baseUrl: process.env.REACT_APP_API_BASE_URL || (isLocalHost ? 'http://localhost:5005/api': 'https://your-production-url.com/api/'),
  imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL || (isLocalHost ? 'http://localhost:5005/public' : 'https://your-production-url.com/public/'),
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://arviss.in/api',
  
  endpoints: {
    login: '/auth/login', 
    register: '/auth/register',
    validate: '/auth/validate',
    logout: '/auth/logout',
    users: '/auth/users',
    updateUser: '/auth/users/update',
    masterPostsAdd: '/master/posts_master/create',
    masterPostsGetAll: '/master/posts_master/get_all',
    masterPostsGetActive: '/master/posts_master/getActiveRecords',
    masterPostsGetOne: '/master/posts_master/getOne',
    masterPostsUpdate: '/master/posts_master/update',
    masterPostsDelete: '/master/posts_master/delete',
    masterEducationTypeAdd: '/master/education_mast/create',
    masterEducationTypeGetAll: '/master/education_mast/get_all',
    masterEducationTypeGetOne: '/master/education_mast/getOne',
    masterEducationTypeUpdate: '/master/education_mast/update',
    masterEducationTypeDelete: '/master/education_mast/delete',
    masterJobTypeAdd: '/master/job_type_mast/create',
    masterJobTypeGetAll: '/master/job_type_mast/get_all',
    masterJobTypeGetOne: '/master/job_type_mast/getOne',
    masterJobTypeUpdate: '/master/job_type_mast/update',
    masterJobTypeDelete: '/master/job_type_mast/delete',
    masterDesignationAdd: '/master/designation_mast/create',
    masterDesignationGetAll: '/master/designation_mast/get_all',
    masterDesignationGetOne: '/master/designation_mast/getOne',
    masterDesignationUpdate: '/master/designation_mast/update',
    masterDesignationDelete: '/master/designation_mast/delete',
    jobApplicationGetAll: '/job_openings/get_all',
    jobApplicationGetActiveTitle: '/job_openings/getActiveTitle',
    jobApplicationGetOne: '/job_openings/getOne',
    jobApplicationCreate: '/job_openings/create',
    jobApplicationFormCreate: '/job_application/create',
    jobApplicationUpdate: '/job_openings/update',
    jobApplicationDelete: '/job_openings/delete',
    getJobApplicationCount: 'job_openings/application-count',
    jobApplicationSendOtp: '/job_application/send_otp',
    jobApplicationVerifyOtp: '/job_application/verify_otp',
    // getCandidates: '/api/candidates',
    jobOpeningsGetCurrentOpening: '/job_openings/get_current_openings',
     getCandidates: '/candidates/list', 
    getJobDetailForView: '/job_openings/get_job_detail_for_view',

    submitStep1: '/job_application/submit_step1',
    submitStep2: '/job_application/submit_step2',
    submitStep3: '/job_application/submit_step3',
    submitStep4: '/job_application/submit_step4',
    submitStep5: '/job_application/submit_step5',

 
  },
};

